import React from 'react';
import cn from 'classnames';
import { FCP } from 'types';

import { SideCard } from 'components/cards/cmpSideCard';
import TopJobsNearYou from 'components/topJobsNearYou';
import ZpButton from 'components/zpButton';
import { scrollTo } from 'utils';

export interface SideCardItem {
  title: string;
  value: string;
  section: string;
  footerText: string;
  isHiddenDesktop?: boolean;
}

interface SideCardsSectionProps extends FCP {
  Tag?: React.ElementType;
  items?: SideCardItem[];
  topJobNearItems?: any[];
  topJobNearCalloutSrc?: string;
  jobTitle?: string;
}

const SideCardsSection = ({
  className = 'w-350',
  Tag = 'aside',
  items = [],
  topJobNearItems = [],
  topJobNearCalloutSrc = '',
  jobTitle = '',
}: SideCardsSectionProps) => {
  const onClick = (target: string) => {
    scrollTo(`#${target}`, 550, false);
  };

  return (
    <Tag className={cn('d-flex flex-column gg-24', className)}>
      {items &&
        items.map(({ title, value, section, footerText, isHiddenDesktop }, index) => (
          <SideCard
            title={title}
            value={value}
            onClick={() => onClick(section)}
            footer={
              <ZpButton size={'big'} theme="link">
                {footerText}
              </ZpButton>
            }
            isHiddenDesktop={isHiddenDesktop}
            key={`${title}_${index}`}
            containerClassName='m-0'
          />
        ))}

      {!!topJobNearItems?.length && jobTitle && (
        <TopJobsNearYou
          jobTitle={jobTitle}
          className='w-350 sticky-top top-65 m-0 h-max'
          items={topJobNearItems}
          src={topJobNearCalloutSrc}
        />
      )}
    </Tag>
  );
};

export default SideCardsSection;
